<button
  type="button"
  class="flex px-3 py-2 items-center bg-[transparent] text-sm enabled:hover:text-action-primary enabled:hover:font-semibold enabled:active:text-action-primary enabled:active:font-semibold"
  [ngClass]="buttonClasses()"
  [disabled]="disabled()"
>
  <ng-content></ng-content>
</button>
